/// <reference types="./getEntitiesUpdatedSeq.d.ts" />
import { ok } from '@dossierhq/core';
import { createSqliteSqlQuery } from '@dossierhq/database-adapter';
import { queryOne } from '../QueryFunctions.js';
export async function getEntitiesUpdatedSeq(database, context) {
    const { query, sql } = createSqliteSqlQuery();
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    sql `UPDATE sequences SET value = value + 1 WHERE name = ${'entities_updated'} RETURNING value`;
    const result = await queryOne(database, context, query);
    if (result.isError())
        return result;
    const { value } = result.value;
    return ok(value);
}
//# sourceMappingURL=getEntitiesUpdatedSeq.js.map